import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [fallbackUrl, setFallbackUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFallbackUrl("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
      if (data?.fallback && data?.reset_url) {
        setFallbackUrl(data.reset_url);
      }
      toast.success("Demande envoyée");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center p-8">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <div className="text-xs uppercase tracking-[0.3em] text-[#FF3B00]">Mot de passe oublié</div>
        <h1 className="font-display text-5xl uppercase mt-2 leading-none">Réinitialiser.</h1>

        {!sent ? (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
            <p className="text-sm text-white/70 leading-relaxed">
              Entrez l'email associé à votre compte. Nous vous enverrons un lien pour créer un nouveau mot de passe.
            </p>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Email</label>
              <input
                data-testid="forgot-email"
                type="email"
                required
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-1 bg-transparent border border-white/20 focus:border-[#FF3B00] outline-none px-4 py-3"
              />
            </div>
            <button
              data-testid="forgot-submit"
              disabled={loading}
              className="w-full py-4 bg-[#FF3B00] text-white uppercase tracking-widest hover:bg-[#E03500] disabled:opacity-50"
            >
              {loading ? "..." : "Envoyer le lien"}
            </button>
            <div className="text-sm text-white/60 text-center">
              <Link to="/login" className="text-[#FF3B00]" data-testid="forgot-back-to-login">
                Retour à la connexion
              </Link>
            </div>
          </form>
        ) : (
          <div className="mt-8 space-y-4" data-testid="forgot-confirmation">
            <div className="border border-white/20 p-6">
              <p className="text-white/90 leading-relaxed">
                Si un compte existe avec cet email, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception (et vos spams).
              </p>
              <p className="mt-3 text-xs text-white/50 uppercase tracking-widest">
                Le lien expire dans 1 heure.
              </p>
            </div>
            {fallbackUrl && (
              <div className="border border-[#FF3B00] bg-[#FF3B00]/10 p-4 text-sm" data-testid="forgot-fallback">
                <div className="text-xs uppercase tracking-[0.3em] text-[#FF3B00] mb-2">Mode dev — Lien direct</div>
                <p className="text-white/80 mb-3">
                  L'envoi email n'est pas encore configuré. Utilisez le lien ci-dessous pour continuer :
                </p>
                <a
                  href={fallbackUrl}
                  className="text-[#FF3B00] underline break-all text-xs"
                  data-testid="forgot-fallback-link"
                >
                  {fallbackUrl}
                </a>
              </div>
            )}
            <div className="text-sm text-center">
              <Link to="/login" className="text-[#FF3B00] uppercase tracking-widest" data-testid="forgot-goto-login">
                Retour à la connexion
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
